import {memo, useCallback, useEffect, useMemo, useState} from 'react';

import {SystemAlert as SystemAlertComponent} from '@macmillanplatform/ui-core';
import {Notification} from '@macmillanplatform/ui-core/types';

import {NOTIFICATIONS_KIND} from '@/constants';

import {readAuthData, updateAuthData} from '@/features/auth/helpers';

import {Notifications} from '@/shared/components';

import './index.css';

interface CarrierUpdateData {
  modified: string;
  dismiss: string;
  subject: string;
  content: string;
  icon: string;
  icon_style: string;
  color: string;
  bg_color: string;
}

type CustomSystemAlert = Notification<
  typeof NOTIFICATIONS_KIND.CARRIER_UPDATE_DELAY,
  CarrierUpdateData
>;

const SystemAlert = () => {
  const {notifications} = Notifications.use();
  const localAuth = readAuthData();
  const [isDismissed, setIsDismissed] = useState<boolean>(
    localAuth?.systemAlert?.dismissed ?? false
  );

  const systemAlert = useMemo(
    () =>
      notifications.find(
        (n): n is CustomSystemAlert =>
          n.kind === NOTIFICATIONS_KIND.CARRIER_UPDATE_DELAY
      ),
    [notifications]
  );

  useEffect(() => {
    if (systemAlert && !localAuth?.systemAlert) {
      updateAuthData({systemAlert});
    }
  }, [systemAlert, localAuth]);

  const onClose = useCallback(() => {
    if (!systemAlert) return;
    updateAuthData({systemAlert: {...systemAlert, dismissed: true}});
    setIsDismissed(true);
  }, [systemAlert]);

  return (
    <SystemAlertComponent
      data={!isDismissed ? systemAlert?.data : null}
      onClose={onClose}
    />
  );
};

export default memo(SystemAlert);
